import CardExpert from '../CardExpert'
import useSWR from 'swr'
import { APIGetPanellists } from '../../endpoints'
import usePageContext from '../Page/context'
import { AwardsModulePanellist } from '../../../types/components'
import getLocalizedEntries from '@utils/getLocalizedEntries'
// import UniversalCookie from 'universal-cookie'

const ModuleDiscoverPagePage = ({ moduleProps }: { moduleProps: AwardsModulePanellist['attributes'] }) => {
  const {
    state: { getEnvConfig }
  } = usePageContext()
  // const Cookies = new UniversalCookie()
  const locale = 'en'
  // const locale = Cookies.get('awardsLocale') || 'en'
  // Getting the labels and the Steps for the Onboarding
  const { data } = useSWR(`${getEnvConfig.NEXT_CMS}${APIGetPanellists()}?locale=${locale}`)

  const localizedData = data && getLocalizedEntries(data, locale)

  return (
    <div className='pt-20 md:pt-[130px] px-0'>
      <h2 className='text-[40px] font-bold leading-[0.85] text-center uppercase whitespace-pre-line font-abcd md:mt-14 mb-14 md:mb-0'>
        {moduleProps.heading}
      </h2>
      <div className='m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-8'>
        {localizedData?.data?.map((item: any, index: number) => (
          <CardExpert
            key={index}
            name={item.attributes.name}
            designation={item.attributes.designation}
            location={item.attributes.location}
            biography={item.attributes.biography}
            image={item.attributes?.image?.data?.attributes?.url}
          />
        ))}
      </div>
    </div>
  )
}

export default ModuleDiscoverPagePage
